import React, {  } from 'react';

import { pluralRulesOptions } from '../types';
import { IntlFunction } from './Intl.Function';

export const IntlPluralRulesResolvedOptions = () => (
	<IntlFunction
		input={[]}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/resolvedOptions"
		header="Intl.PluralRules.prototype.resolvedOptions"
		description="Returns a new object with properties reflecting the locale and plural formatting options computed during initialization of this [Intl.PluralRules](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules) object."
		options={pluralRulesOptions}
		ruleSet={[]}
		template="new Intl.PluralRules(##locale##, ##options##).resolvedOptions()" />
)